module.exports = __webpack_public_path__ + "img/zhongzhi.28d83d0d.png";